<div class="buttons {{ buttonProperties?.class }}" [ngClass]="{
    'radius-button': buttonProperties?.radius
  }" [title]="buttonProperties?.tooltip || buttonProperties?.label">
  <button *ngIf="!buttonProperties.dropDown"
    class="button-generic {{ buttonProperties.elongated ? 'long-button' : '' }}" 
    [disabled]="buttonProperties.disabled || isLoading"
    [class.primary]="buttonProperties.customStyle === 'primary'"
    [class.secondary]="buttonProperties.customStyle === 'secondary'"
    [class.tertiary]="buttonProperties.customStyle === 'tertiary'"
    [class.cancel]="buttonProperties.customStyle === 'cancel'" [class.mini]="buttonProperties.customStyle === 'mini'"
    [class.iconButton]="buttonProperties.icon && !buttonProperties.showLabel"
    [class.icon-fill]="buttonProperties.customStyleFillIcon"
    [ngClass]="{ 'disabled': buttonProperties.disabled || isLoading, 'wIcon': buttonProperties.showLabel, 'loading': isLoading }"
    (click)="onButtonClicked($event, buttonProperties?.key)">
    
    <div *ngIf="isLoading" class="button-spinner"></div>
    
    <icon-induxtry *ngIf="buttonProperties.icon && buttonProperties.iconPosition !== 'right' && !isLoading" [icon]="{ icon: buttonProperties.icon, width: 24, height: 24}"></icon-induxtry>

    <span *ngIf="buttonProperties.showLabel && !isLoading" [ngClass]="{ 'label': buttonProperties.icon }">
      {{ buttonProperties.label}}
    </span>
    
    <span *ngIf="isLoading && buttonProperties.showLabel" class="loading-label">
      Carregando...
    </span>

    <icon-induxtry *ngIf="buttonProperties.icon && buttonProperties.iconPosition === 'right' && !isLoading" [icon]="{ icon: buttonProperties.icon, width: 24, height: 24 }"></icon-induxtry>
  </button>

  <!-- DropDown Button -->
  <button *ngIf="buttonProperties.dropDown" [matMenuTriggerFor]="menu"
    class="button-generic {{ buttonProperties.elongated ? 'long-button' : '' }}" 
    [disabled]="buttonProperties.disabled || isLoading"
    [class.primary]="buttonProperties.customStyle === 'primary'"
    [class.secondary]="buttonProperties.customStyle === 'secondary'"
    [class.tertiary]="buttonProperties.customStyle === 'tertiary'"
    [class.cancel]="buttonProperties.customStyle === 'cancel'" 
    [ngClass]="{ 'disabled': buttonProperties.disabled || isLoading, 'loading': isLoading }"
    [class.mini]="buttonProperties.customStyle === 'mini'"
    [class.iconButton]="buttonProperties?.dropDown && buttonProperties.icon && !buttonProperties.showLabel"
    (click)="onButtonClicked($event, buttonProperties?.key)"
    [style.padding]="buttonProperties?.dropDown && !buttonProperties?.showLabel ? '6px' : null">
    
    <div *ngIf="isLoading" class="button-spinner"></div>
    
    <icon-induxtry *ngIf="buttonProperties.icon && !isLoading" [icon]="{ icon: buttonProperties.icon, width: 30, height: 30 }"></icon-induxtry>

    <span *ngIf="buttonProperties.showLabel && !isLoading" [ngClass]="{ 'label': buttonProperties.icon }">
      {{ buttonProperties.label}}
    </span>
    
    <span *ngIf="isLoading && buttonProperties.showLabel" class="loading-label">
      Carregando...
    </span>
  </button>
  <mat-menu #menu="matMenu" [class]="'menu-dropdown-button-induxtry ' + buttonProperties.customStyle">
    <div *ngFor="let item of buttonProperties.dropDownBtns" matTooltip="{{item?.tooltip}}"
      matTooltipClass="induxtry-tooltip">
      <button class="dropdown-button-induxtry" mat-menu-item [disabled]="item.disabled"
        (click)="onButtonClicked($event, item.key)">
        <icon-induxtry *ngIf="item.icon" [icon]="{ icon: item.icon, width: 30, height: 30 }"></icon-induxtry>
        <span [ngClass]="{ 'label': item.icon }">
          {{ item.label}}
        </span>
      </button>
    </div>
  </mat-menu>
</div>